export default __webpack_public_path__ + "static/media/bg-2.a2ac82e6.jpg";